import React from 'react';

import Text, { TextContent } from '@lightspeed/cirrus-text';
import PropTypes from 'prop-types';

import Wrapper from './Wrapper';

const Section = ({ children, title, description, extra }) => (
  <Wrapper className="cr-layout__section">
    <div className="cr-width-full cr-width-4-12-md cr-width-3-12-lg cr-mb-2 cr-pr-2">
      <TextContent>
        <Text heading4 element="div" data-test="layout-section-title">
          {title}
        </Text>
        {description && (
          <Text element="div" data-test="layout-section-description" bodySmall dimmed>
            {description}
          </Text>
        )}
        {extra}
      </TextContent>
    </div>
    <div
      className="cr-width-full cr-width-8-12-md cr-width-9-12-lg"
      data-test="layout-section-content"
    >
      {children}
    </div>
  </Wrapper>
);

Section.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  description: PropTypes.node,
  extra: PropTypes.node,
};

Section.defaultProps = {
  title: '',
  description: null,
  extra: null,
};

export default Section;
